interface RenderCountProps {
  renderCount: number
}

export const RenderCount = ({renderCount}: RenderCountProps) => {
  return (
    <div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 transform flex-col items-center justify-center">
      <div
        id="click-counter"
        className="select-none text-[40px] leading-[40px] text-white drop-shadow-sm"
      >
        {renderCount}
      </div>
      <div id="click-text" className="select-none text-xl text-white drop-shadow-sm">
        Klikk
      </div>
    </div>
  )
}
